import { render } from "./DocumentClassForm.vue?vue&type=template&id=1ba33c64&ts=true"
import script from "./DocumentClassForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__